import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'productName',
      type: 'input',
      label: '商品名',
      placeholder: '请输入商品名'
    },
    {
      field: 'customerName',
      type: 'input',
      label: '客户姓名',
      placeholder: '请输入客户姓名'
    },
    {
      field: 'nickname',
      type: 'input',
      label: '微信昵称',
      placeholder: '请输入微信昵称'
    },
    {
      field: 'unionid',
      type: 'input',
      label: '客户unionid',
      placeholder: '请输入客户unionid'
    },
    {
      field: 'channelName',
      type: 'input',
      label: '直播间名称',
      placeholder: '请输入直播间名称'
    },
    {
      label: '是否已签约',
      field: 'isSigned',
      type: 'select',
      clearable: true,
      placeholder: '请选择是否已签约',
      options: [
        { title: '是', value: '是' },
        { title: '否', value: '否' }
      ]
    },
    {
      label: '支付渠道',
      field: 'channelCode',
      type: 'select',
      clearable: true,
      placeholder: '请选择支付渠道',
      options: [
        { title: '钱包', value: 'wallet' },
        { title: '模拟支付', value: 'mock' },
        { title: '支付宝扫码支付', value: 'alipay_qr' },
        { title: '支付宝条码支付', value: 'alipay_bar' },
        { title: '支付宝 App 支付', value: 'alipay_app' },
        { title: '支付宝 Wap 网站支付', value: 'alipay_wap' },
        { title: '支付宝 PC 网站支付', value: 'alipay_pc' },
        { title: '微信条码支付', value: 'wx_bar' },
        { title: '微信扫码支付', value: 'wx_native' },
        { title: '微信 App 支付', value: 'wx_app' },
        { title: '微信小程序支付', value: 'wx_lite' },
        { title: '微信公众号支付', value: 'wx_pub' },
        { title: '微信 Wap 网站支付', value: 'wx_wap' },
      ]
    },
    {
      label: '支付状态',
      field: 'status',
      type: 'select',
      clearable: true,
      placeholder: '请选择支付状态',
      options: [
        { title: '等待支付', value: '0' },
        { title: '支付成功', value: '10' },
        { title: '已退款', value: '20' },
        { title: '支付关闭', value: '30' },
        { title: '失败（三方订单不存在）', value: '40' },
        { title: '已过期（超过一周未完成支付）', value: '50' },
      ]
    },
    {
      label: '是否退款',
      field: 'isRefund',
      type: 'select',
      clearable: true,
      placeholder: '请选择是否退款',
      options: [
        { title: '是', value: '是' },
        { title: '否', value: '否' }
      ]
    },
    {
      field: 'payTime',
      type: 'datepicker',
      label: '购买时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
